// extracted by mini-css-extract-plugin
export var closeButton = "_42-3";
export var header = "_42-0";
export var link = "_42-1";
export var retryButton = "_42-2";